export class SearchOverlayData {
  public term: string;
  public auth: boolean;
  public costEnabled: boolean;

  constructor(obj: SearchOverlayData) {
    this.term = obj.term || '';
    this.auth = obj.auth || false;
    this.costEnabled = obj.costEnabled || false;
  }
}
